import React from "react";
import { useForm } from "react-hook-form";
import {
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import toast from "react-hot-toast";

function ContactPage() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    // Simulate form submission
    await new Promise((resolve) => setTimeout(resolve, 1000));

    console.log("Contact form data:", data);
    toast.success(
      "Mesajınız başarıyla gönderildi! En kısa sürede dönüş yapacağız."
    );
    reset();
  };

  /*const contactInfo = [
    {
      icon: EnvelopeIcon,
      title: "E-posta",
      content: "support@kslnk.link",
      description: "Destek ve genel sorular için",
    },
    {
      icon: PhoneIcon,
      title: "Telefon",
      content: "+90 (555) 123-4567",
      description: "Acil durumlar için",
    },
    {
      icon: MapPinIcon,
      title: "Adres",
      content: "İstanbul, Türkiye",
      description: "Merkez ofisimiz",
    },
    {
      icon: ClockIcon,
      title: "Çalışma Saatleri",
      content: "24/7 Online Destek",
      description: "Her zaman yanınızdayız",
    },
  ];*/

  const contactInfo = [
    {
      icon: EnvelopeIcon,
      title: "E-posta",
      content: "support@kslnk.link",
      description: "Destek ve genel sorular için",
    },
    {
      icon: ClockIcon,
      title: "Çalışma Saatleri",
      content: "24/7 Online Destek",
      description: "Her zaman yanınızdayız",
    },
  ];

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            İletişime Geçin
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Sorularınız mı var? Yardıma mı ihtiyacınız var? Ekibimiz size
            yardımcı olmak için burada!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="card">
            <div className="card-header">
              <h2 className="text-xl font-semibold text-gray-900">
                Mesaj Gönder
              </h2>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ad
                    </label>
                    <input
                      type="text"
                      className={`form-input ${errors.firstName ? "error" : ""}`}
                      placeholder="Adınız"
                      {...register("firstName", {
                        required: "Ad gereklidir",
                        maxLength: {
                          value: 50,
                          message: "En fazla 50 karakter",
                        },
                      })}
                    />
                    {errors.firstName && (
                      <p className="mt-1 text-sm text-error-600">
                        {errors.firstName.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Soyad
                    </label>
                    <input
                      type="text"
                      className={`form-input ${errors.lastName ? "error" : ""}`}
                      placeholder="Soyadınız"
                      {...register("lastName", {
                        required: "Soyad gereklidir",
                        maxLength: {
                          value: 50,
                          message: "En fazla 50 karakter",
                        },
                      })}
                    />
                    {errors.lastName && (
                      <p className="mt-1 text-sm text-error-600">
                        {errors.lastName.message}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta
                  </label>
                  <input
                    type="email"
                    className={`form-input ${errors.email ? "error" : ""}`}
                    placeholder="email@example.com"
                    {...register("email", {
                      required: "E-posta gereklidir",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Geçerli bir e-posta adresi girin",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className="mt-1 text-sm text-error-600">
                      {errors.email.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Konu
                  </label>
                  <select
                    className={`form-select ${errors.subject ? "error" : ""}`}
                    {...register("subject", { required: "Konu seçiniz" })}
                  >
                    <option value="">Konu seçiniz</option>
                    <option value="general">Genel Sorular</option>
                    <option value="technical">Teknik Destek</option>
                    <option value="payment">Ödeme Sorunları</option>
                    <option value="account">Hesap Sorunları</option>
                    <option value="business">İş Ortaklığı</option>
                    <option value="other">Diğer</option>
                  </select>
                  {errors.subject && (
                    <p className="mt-1 text-sm text-error-600">
                      {errors.subject.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mesaj
                  </label>
                  <textarea
                    rows="5"
                    className={`form-textarea ${errors.message ? "error" : ""}`}
                    placeholder="Mesajınızı buraya yazın..."
                    {...register("message", {
                      required: "Mesaj gereklidir",
                      minLength: { value: 10, message: "En az 10 karakter" },
                      maxLength: {
                        value: 1000,
                        message: "En fazla 1000 karakter",
                      },
                    })}
                  />
                  {errors.message && (
                    <p className="mt-1 text-sm text-error-600">
                      {errors.message.message}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full btn btn-primary btn-lg"
                >
                  {isSubmitting ? "Gönderiliyor..." : "Mesaj Gönder"}
                </button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            {contactInfo.map((info) => {
              const Icon = info.icon;
              return (
                <div key={info.title} className="card">
                  <div className="card-body">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <Icon className="w-6 h-6 text-primary-600" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-1">
                          {info.title}
                        </h3>
                        <p className="text-lg text-gray-900 mb-1">
                          {info.content}
                        </p>
                        <p className="text-gray-600 text-sm">
                          {info.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* FAQ Link */}
            <div className="card bg-blue-50 border-blue-200">
              <div className="card-body">
                <h3 className="font-semibold text-blue-900 mb-2">
                  Sık Sorulan Sorular
                </h3>
                <p className="text-blue-800 text-sm mb-4">
                  Sorunuzun cevabı burada olabilir
                </p>
                <a href="/page/faq" className="btn btn-primary btn-sm">
                  SSS'yi İncele
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
